<template>
  <v-navigation-drawer
    v-bind="$attrs"
    v-on="$listeners"
    v-model="showDrawer"
    app
    class="rounded-r-xl container"
    temporary
  >
    <v-list
      nav
      dense
    >
      <v-list-item-group>
        <v-container class="mt-2">
          <p style="drawer-name-user" class="ml-1">Hola</p>
          <p style="drawer-name-user__desk" class="ml-1">{{user.genero ? user.genero.pronombre : null}} {{ nombreUsuario }}</p>
        </v-container>
        <v-container class="">
          <v-card width="100%" height="145" class="mb-5">
            <v-img
              :src="drawerImage || defaultDrawerImage"
            />
          </v-card>
        </v-container>
        <v-container class="">
          <v-list-item :to="{name:'Perfil'}">
            <v-list-item-title class="font-size-1 font-weight-normal my-1" style="font-size: 12px !important;">
              <v-list-item-avatar height="25px" style="border-radius:inherit!important">
                <img
                  src="@/assets/icon/user.svg"
                >
              </v-list-item-avatar>
              Datos de Perfil
            </v-list-item-title>
          </v-list-item>
          <!-- <v-list-item>
            <v-list-item-title class="my-3 font-size-1 font-weight-normal">
              <v-list-item-avatar height="25px" style="border-radius:inherit!important"><img
                src="@/assets/icon/tarjeta.svg"></v-list-item-avatar>
              Métodos de pagos
            </v-list-item-title>
          </v-list-item> -->
          <v-list-item>
            <v-list-item-title @click="changeActiveCuponPremiumModal" class="my-1 font-size-1 font-weight-normal;"
                               style="font-size: 12px !important;">
              <v-list-item-avatar height="25px" style="border-radius:inherit!important"><img
                src="@/assets/icon/class-menu.svg"></v-list-item-avatar>
              Cursos
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="$vuetify.breakpoint.mdAndDown">
            <v-list-item-title @click="changeActiveCuponPremiumModal" class="my-1 font-size-1 font-weight-normal;"
                               style="font-size: 12px !important;">
              <v-list-item-avatar height="25px" style="border-radius:inherit!important">
                <v-icon size="32" color="#232323">mdi-crown</v-icon>
              </v-list-item-avatar>
              Usar Cupón
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title @click="doLogout" class="font-size-1 font-weight-normal my-1"
                               style="font-size: 12px !important;">
              <v-list-item-avatar height="25px" style="border-radius:inherit!important;"><img
                src="@/assets/icon/exit.svg"></v-list-item-avatar>
              Cerrar Sesión
            </v-list-item-title>
          </v-list-item>
          <div class="mx-5 mt-4 d-flex" style="font-size: 12px;">
            Powered by <p @click="$router.push({ name: 'Creditos' })" class="pl-1" style="cursor: pointer; color: #0583DA !important;  text-decoration: none !important;">Divelia</p>
          </div>
        </v-container>
      </v-list-item-group>
    </v-list>
    <the-drawer-footer
      :isPremium="user.is_premium"
    />
    <clases-modal v-model="clasesModal"/>
    <cupon-premium-modal
      v-model="cuponPremiumModal"
      @close="cuponPremiumModal = false"
    />
    <!--      <v-container bottom class="d-flex justify-center">-->
    <!--        <img src="@/assets/img/medicos.svg" alt="">-->
    <!--      </v-container>-->
  </v-navigation-drawer>

</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { unsubscribeToSession } from '@/utils/pusher'
import ClasesModal from '@/components/ClasesModal.vue'
import TheDrawerFooter from '@/components/TheDrawerFooter.vue'
import defaultDrawerImage from '@/assets/img/drawer-promo.svg'
import CuponPremiumModal from '@/components/CuponPremiumModal.vue'
import axios from 'axios'

export default {
  inheritAttrs: false,
  components: { ClasesModal, TheDrawerFooter, CuponPremiumModal },
  props: {},
  data () {
    return {
      clasesModal: false,
      drawerImage: null,
      defaultDrawerImage,
      cuponPremiumModal: false
    }
  },
  computed: {
    ...mapState('perfil', ['user']),
    ...mapState(['drawer']),
    ...mapGetters('perfil', ['nombreUsuario']),
    showDrawer: {
      get () {
        return this.drawer
      },
      set (value) {
        this.SET_DRAWER(value)
      }
    }
  },
  methods: {
    ...mapActions(['logout', 'saveIpInformation']),
    ...mapMutations(['SET_DRAWER']),
    ...mapActions('perfil', ['fetchUser']),
    doLogout () {
      this.logout()
      unsubscribeToSession()
      this.$router.push({ name: 'Login' })
    },
    changeClasesModal () {
      this.clasesModal = !this.clasesModal
    },
    changeActiveCuponPremiumModal () {
      this.cuponPremiumModal = !this.cuponPremiumModal
    },
    async getIpInformation () {
      const response = await fetch(`${process.env.VUE_APP_IP_DATA_API_URL}?api-key=${process.env.VUE_APP_IP_DATA_API_KEY}`)
      return await response.json()
    },
    async getAndSaveIpInformation () {
      if (!this.user) return
      try {
        const response = await this.getIpInformation()
        const payload = {
          user: this.user.id,
          ip: response.ip,
          ciudad: response.city || '-',
          region: response.region || '-',
          pais: response.country_name,
          postal: response.postal || '-',
          emoji_bandera: response.emoji_flag,
          app: 'BANQUEO'
        }
        this.saveIpInformation(payload)
      } catch (err) {
        console.log(err)
      }
    },
    async fetchDrawerImage () {
      try {
        const imageResponse = await axios.get('api/banqueo/imagenes/BANQUEO_DRAWER')
        this.drawerImage = imageResponse.data.imagen
      } catch (e) {
        return false
      }
    }
  },
  async mounted () {
    await this.fetchUser()
    await this.fetchDrawerImage()
    this.getAndSaveIpInformation()
  }
}
</script>
<style lang="scss" scoped>
.drawer-name-user {
  font-size: 15px;
  font-weight: 400;

  &__desk {
    font-weight: 700;
    width: 180px;
    text-overflow: ellipsis !important;
    overflow: hidden;
  }
}
</style>
